/**
 * forEach iterates through the provided object entries, calling the iteratee function
 * for each key-value pair. Similar to Array.prototype.forEach but for objects.
 *
 * @param {object} object the object to iterate over
 * @param {Function} iteratee Function called for each entry with parameters (value, key, object)
 */
export const forEach = (object, iteratee) => {
  const objectToIterate = object ?? {};

  if (typeof iteratee === "function") {
    Object.entries(objectToIterate).forEach(([key, value]) => {
      iteratee(value, key, objectToIterate);
    });
  }
};
